import type { FeatureName } from '~/shared/feature-flag-service/feature-flag-service';

// The canvas ships with the new UI, so either of its flags makes it available.
const canvasFeatureFlags: readonly FeatureName[] = ['new-dashboard', 'workspace-navigation'];

export const isCanvasReleased = (isFeatureFlagEnabled: (name: FeatureName) => boolean): boolean =>
    canvasFeatureFlags.some(isFeatureFlagEnabled);
